import * as XLSX from 'xlsx';

export class ReportExportService {

  exportToExcel(data: any[], fileName: string) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = {
      Sheets: { data: ws },
      SheetNames: ['data']
    };

    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}